import { makeStyles } from '@mui/styles';

const useStyles = makeStyles((theme) => ({
  iconWrapper: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    padding: '4px',
    borderRadius: '50%',
    transition: 'background-color 0.2s ease',
    '&:hover': {
      backgroundColor: theme.palette.grey[200],
    },
  },
  completedIcon: {
    color: theme.palette.success.main,
  },
  inProgressIcon: {
    color: theme.palette.error.main,
    animation: '$spin 1.5s linear infinite',
  },
  '@keyframes spin': {
    '0%': {
      transform: 'rotate(0deg)',
    },
    '100%': {
      transform: 'rotate(360deg)',
    },
  },
  modalContent: {
    maxHeight: '400px',
    overflowY: 'auto',
    padding: '8px 0',
  },
  resyncTable: {
    width: '100%',
    borderCollapse: 'collapse',
    '& th, & td': {
      padding: '12px 16px',
      textAlign: 'left',
      borderBottom: `1px solid ${theme.palette.grey[300]}`,
    },
    '& th': {
      backgroundColor: theme.palette.grey[200],
      fontWeight: 600,
      color: theme.palette.secondary.dark,
      position: 'sticky',
      top: 0,
      zIndex: 1,
    },
    '& td': {
      color: theme.palette.grey[800],
    },
    '& tr:hover td': {
      backgroundColor: theme.palette.grey[100],
    },
  },
  statusChip: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '4px',
    padding: '4px 8px',
    borderRadius: '16px',
    fontSize: '12px',
    fontWeight: 500,
  },
  completedStatus: {
    backgroundColor: theme.palette.success.lighter,
    color: theme.palette.success.dark,
  },
  inProgressStatus: {
    backgroundColor: theme.palette.warning.lighter,
    color: theme.palette.warning.dark,
  },
  tooltipContent: {
    padding: '4px 8px',
    fontSize: '12px',
  },
  noDataRow: {
    textAlign: 'center',
    color: theme.palette.grey[500],
    padding: '24px',
  },
}));

export default useStyles;
